// tanstack
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_admin/operations/predictive-heat-control',
)({
  component: () => <Outlet />,
  staticData: { crumb: 'glossary:predictive-heat-control' },
});
